// App Settings Store
export const SESSION_TIME_FINISHED = "SESSION_TIME_FINISHED";
export const SHOW_TOASTER_MESSAGE = "SHOW_TOASTER_MESSAGE";
export const SCROLL_TOP = "SCROLL_TOP";
export const LOADING = "LOADING"


// WEBPACK FOOTER //
// ./src/constants/event-names.js